<script setup>
  import PL_StandardA4X2NA from './pl/StandardA4X2NA.vue';
  import PL_StandardA4X2EB from './pl/StandardA4X2EB.vue';
  import PL_StandardA4X2NABev from './pl/StandardA4X2NABev.vue';
  import PL_StandardA4X2NADW5 from './pl/StandardA4X2NADW5.vue';
  import PL_StandardA4X2NADW5V2 from './pl/StandardA4X2NADW5V2.vue';
  import DE_StandardA4X2NA from './de/StandardA4X2NA.vue';
  import DE_StandardA4X2EB from './de/StandardA4X2EB.vue';
  import DE_StandardA4X2NADW5 from './de/StandardA4X2NADW5.vue';
  import DE_StandardA4X2NADW6 from './de/StandardA4X2NADW6.vue';
  import CH_StandardRigid from './ch/StandardRigid.vue';
  import CH_StandardTractor from './ch/StandardTractor.vue';
  import CH_StandardStock from './ch/StandardStock.vue';
  import JP_StandardRigid from './jp/StandardRigid.vue';
  import JP_StandardTractor from './jp/StandardTractor.vue';

  const emit = defineEmits(['select']);

  defineProps({
    offerTemplate: {
      type: String,
      default: '',
    },
    specType: {
      type: String,
      default: '',
    },
    isFrameAgreement: {
      type: Boolean,
      default: false,
    },
  });

  const componentMapping = {
    'PL_STANDARDA4X2EB': PL_StandardA4X2EB,
    'PL_STANDARDA4X2NA': PL_StandardA4X2NA,
    'PL_STANDARDA4X2NA_BEV': PL_StandardA4X2NABev,
    'PL_STANDARDA4X2NA_DW5': PL_StandardA4X2NADW5,
    'PL_STANDARDA4X2NA_DW5_V2': PL_StandardA4X2NADW5V2,
    'PL_INDEX': PL_StandardA4X2NA,
    'DE_STANDARDA4X2EB': DE_StandardA4X2EB,
    'DE_STANDARDA4X2NA': DE_StandardA4X2NA,
    'DE_STANDARDA4X2NA_DW5': DE_StandardA4X2NADW5,
    'DE_STANDARDA4X2NA_DW6': DE_StandardA4X2NADW6,
    'DE_INDEX': DE_StandardA4X2NA,
    'CH_STANDARD_RIGID': CH_StandardRigid,
    'CH_STANDARD_TRACTOR': CH_StandardTractor,
    'CH_STANDARD_STOCK': CH_StandardStock,
    'CH_INDEX': CH_StandardTractor,
    'JP_STANDARD_RIGID': JP_StandardRigid,
    'JP_STANDARD_TRACTOR': JP_StandardTractor,
    'JP_INDEX': JP_StandardTractor,
  };

  const handleOptionSelect = (object, section) => {
    emit('select', object, section);
  };
</script>

<template>
  <component
    :is="componentMapping[offerTemplate]"
    :offer-template="offerTemplate"
    :spec-type="specType"
    :is-frame-agreement="isFrameAgreement"
    @select="handleOptionSelect"
  />
</template>
